<template>
  <ul class="specialopt-options">
    <li
      v-for="item in master"
      :key="item.id"
    >
      <h3
        class="subtitle-1"
        :class="{'is-selected': values[item.id] > 0}"
      >
        <span class="name">{{item.name}}</span>
        <span class="price body-2">
          <em>{{item.price | comma}}</em>
          <small>{{item.priceType | priceType}}</small>
        </span>
      </h3>
      <v-row>
        <v-col v-if="item.image" cols="6">
          <v-img
            :src="item.image"
            contain
          />
        </v-col>
        <v-col :cols="item.image ? 6 : 12">
          <pre v-if="item.desc" class="body-2" :class="{'no-image': !item.image}">{{item.desc}}</pre>

          <div
            v-if="item.max == 1 && !item.unit"
            class="item-switch" :class="{'no-image': !item.image}"
          >
            <v-switch
              v-model="values[item.id]"
            />
          </div>

          <div
            v-else
            class="item-select" :class="{'no-image': !item.image}"
          >
            <v-select
              v-model="values[item.id]"
              :items="quantities(item.max)"
            >
              <template #selection="{item: q}">
                <span v-if="q == 0">なし</span>
                <span v-else>{{q}} {{item.unit}}</span>
              </template>
              <template #item="{item: q}">
                <span v-if="q == 0">なし</span>
                <span v-else>{{q}} {{item.unit}}</span>
              </template>
            </v-select>
          </div>
        </v-col>
      </v-row>
    </li>
  </ul>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';

.v-application .specialopt-options {
  padding: 0;
  border: solid 1px rgba(black, 0.12);
  border-top-style: none;

  > li {
    list-style: none;
    border-top: solid 1px rgba(black, 0.12);
    background-color: white;
  }

  h3 {
    display: flex;
    flex-flow: row nowrap;
    align-items: baseline;
    background-color: #f4f4f4;
    padding: 10px 16px;

    .name {
      font-weight: bold;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .price {
      white-space: nowrap;
      margin-left: 1em;
    }

    em {
      font-style: normal;
    }

    small {
      margin-left: .5em;
    }
  }

  h3.is-selected {
    background-color: $info-color;
    color: white;
  }

  pre {
    white-space: pre-wrap;
    margin: {
      right: 16px;
      bottom: 8px;
    }
  }

  pre.no-image {
    margin-left:16px;
  }

  .item-select {
    margin-right: 16px;
  }

  .item-select.no-image {
    margin-left: calc(50% + 12px);
  }

  .item-switch {
    margin-right: 16px;
  }

  .item-switch.no-image {
    margin-left: calc(100% - 38px - 16px);
  }

  .v-input {
    margin-top: 0;
    padding-top: 0;
  }
}

.v-application .specialopt-options:empty {
  border: none;
}
</style>

<script>
import PartBase from '@/mixins/PartBase'
import * as C from '@/app/special/consts'

export default {
  name: 'OptOptions',
  mixins: [
    PartBase
  ],
  props: {
    master: {
      type: Array,
      required: true
    },
    values: {
      type: Object,
      required: true
    }
  },
  filters: {
    priceType (type) {
      return type === C.PRICETYPE_TIME ? '円/回' : '円/日'
    }
  },
  methods: {
    quantities (max) {
      const q = new Array(max + 1)
      for (let n = 0; n <= max; ++n) {
        q[n] = n
      }
      return q
    }
  }
}
</script>
